import { createActionsHook } from 'src/lib/sweetState';

import { BrandVoicesStore } from './BrandVoicesStore';

export const useBrandVoicesActions = createActionsHook(BrandVoicesStore);
